import { ActionType, createReducer } from 'typesafe-actions';

import * as actions from './profile.action';
import { Profile, ProfileState } from './type';

/**
 * What consumers see before the fetch settles, and after sign-out.
 *
 * This mirrors react-redux-firebase's initial profile shape on purpose: the seven sites
 * that gate on isLoaded/isEmpty were written against rrf's "unloaded, then loaded"
 * lifecycle, and keeping it means none of them change.
 */
export const PROFILE_UNLOADED: Profile = { isLoaded: false, isEmpty: true };

export const initialState: ProfileState = {
	profile: PROFILE_UNLOADED,
	error: null
};

export type ProfileAction = ActionType<typeof actions>;

export const profileReducer = createReducer<ProfileState, ProfileAction>(initialState)
	.handleAction(actions.fetchProfileAsync.request, (state) => ({ ...state, error: null }))
	.handleAction(actions.fetchProfileAsync.success, (_state, action) => ({
		profile: { ...action.payload.user, isLoaded: true, isEmpty: false },
		error: null
	}))
	.handleAction(actions.fetchProfileAsync.failure, (_state, action) => ({
		// Loaded but empty, deliberately. Reporting a populated profile without an
		// organization would let the gates admit a session whose org-scoped queries run
		// unscoped; empty sends the user back to login instead.
		profile: { isLoaded: true, isEmpty: true },
		error: action.payload.error
	}))
	.handleAction(actions.clearProfile, () => initialState);

export default profileReducer;
